/* eslint-disable */
import { produce } from "immer";
import {
  POST_CONTRIBUTION_RATES_FETCH_FAILURE,
  POST_CONTRIBUTION_RATES_FETCH_START,
  POST_CONTRIBUTION_RATES_FETCH_SUCCESS,
  RESET_CONTRIBUTION_RATES_DATA,
} from "../actions/types";

const postManage = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case POST_CONTRIBUTION_RATES_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case POST_CONTRIBUTION_RATES_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case POST_CONTRIBUTION_RATES_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    case RESET_CONTRIBUTION_RATES_DATA:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.data = [];
      });
    default:
      return state;
  }
};

export default postManage;
